import { useEffect, useMemo, useRef, useState } from 'react';

const AD_BANNER_URL = '/ad_banner.html';

interface UseAdBannerParams {
  ptype?: number;
  grade?: number;
  region?: number;
  enabled: boolean;
}

export const useAdBanner = ({
  ptype,
  grade,
  region,
  enabled,
}: UseAdBannerParams) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const src = useMemo(() => {
    if (!enabled) {
      return undefined;
    }

    const params = new URLSearchParams();

    if (ptype !== undefined) {
      params.set('ptype', String(ptype));
    }

    if (grade !== undefined) {
      params.set('grade', String(grade));
    }

    if (region !== undefined) {
      params.set('region', String(region));
    }

    const bxPreview = new URLSearchParams(window.location.search).get(
      'bx_preview',
    );

    if (bxPreview) {
      params.set('bx_preview', bxPreview);
    }

    return `${AD_BANNER_URL}?${params.toString()}`;
  }, [enabled, ptype, grade, region]);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.source !== iframeRef.current?.contentWindow) {
        return;
      }

      if (event.data?.type === 'adBannerLoaded') {
        setIsLoaded(true);
        setIsEmpty(false);
      }

      if (event.data?.type === 'adBannerEmpty') {
        setIsEmpty(true);
      }
    };

    window.addEventListener('message', onMessage);

    return () => window.removeEventListener('message', onMessage);
  }, []);

  return { iframeRef, src, isEmpty, isLoaded };
};
